import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNiconicoComponent } from './simple-icons-niconico.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNiconicoComponent ],
    exports:      [ SimpleIconsNiconicoComponent ],
    bootstrap:    []
})
export class SimpleIconsNiconicoModule {}
